export default __webpack_public_path__ + "static/about1-e8d56dd91981c00de0558d6a0fc87bc1.webp";